import api from '@/apis/di/accountAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance, ref } from 'vue';
import { ModuleAccount } from '@/stores/moduleConst';

// Combo grid Tài khoản nợ, có
export const useAccountCustomComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  /**
   * Load combo nếu Dboption tick hạn chế tài khoản
   * @param {*} keyRow Key của cột lọc tài khoản
   * @param {*} extend
   * @param {*} payload
   * NXCHIEN 10.07.2022
   */
  function buildFilterCombo(keyRow, extend, payload, row, ors) {
    // Nếu cột lọc TK ko có giả trị thì bỏ qua tất cả;
    if (proxy.defaultData && proxy.defaultData[keyRow]) {
      let arrAccount = proxy.defaultData[keyRow].split(';');
      let accountFilter = {
        Field: 'account_number',
        Operator: proxy.$ms.constant.FilterOperator.StartsWith,
        Value: arrAccount[0],
        Ors: [],
      };
      if (arrAccount.length > 1) {
        for (let i = 1; i < arrAccount.length; i++) {
          let item = arrAccount[i];
          accountFilter.Ors.push({
            Field: 'account_number',
            Operator: proxy.$ms.constant.FilterOperator.StartsWith,
            Value: item,
          });
        }
      }
      let orsIsParent = [{ Field: 'is_parent', Operator: 'NULL' }];
      extend.splice(0, extend.length);
      extend.push({ Field: 'inactive', Value: false, Ors: ors });
      extend.push({ Field: 'is_parent', Value: false, Ors: orsIsParent });
      extend.push(accountFilter);
    }
  }

  // func call api lấy dữ liệu combo từ danh sách tài khoản chi tiết nhất, riêng với tk 006, 008, 009 load lên tk chi tiết nhất và cha liền kề nó
  const onAccountComboboxLoadDataCustom = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let orsIsParent = [{ Field: 'is_parent', Operator: 'NULL' }];
    let ors2 = [{ Field: 'is_parent', Value: false, Ors: orsIsParent }];

    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      {
        Field: 'account_number',
        Operator: 'IN',
        Value: ['0061', '0062', '00811', '00812', '00813', '00821', '00822', '00823', '0091', '0092', '0093'],
        Ors: ors2,
      },
    ];
    payload.sort = 'account_number';

    // có tick hạn chế TK thì lấy dữ liệu cột Lọc trong TK ngầm định
    if (proxy.dbOptions?.AllowRestrictAccountNumber) {
      if (column.dataField == 'debit_account') {
        buildFilterCombo('default_debit_account_category_id', extend, payload, row, ors);
      } else if (column.dataField == 'credit_account') {
        buildFilterCombo('default_credit_account_category_id', extend, payload, row, ors);
      }
      //Thêm trường hợp là tài khoản thuế
      //TVDAT 15/07/2022
      else if (column.dataField == 'tax_account') {
        buildFilterCombo('default_tax_account_category_id', extend, payload, row, ors);
      }
    }
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  /**
   * Lấy filter cho form tìm nhanh
   * @param {*} param
   * @returns
   */
  const onAccountComboboxPayload = param => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let orsIsParent = [{ Field: 'is_parent', Operator: 'NULL' }];
    let ors2 = [{ Field: 'is_parent', Value: false, Ors: orsIsParent }];
    let payload = {};

    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      {
        Field: 'account_number',
        Operator: 'IN',
        Value: ['0061', '0062', '00811', '00812', '00813', '00821', '00822', '00823', '0091', '0092', '0093'],
        Ors: ors2,
      },
    ];
    payload.sort = 'account_number';

    // có tick hạn chế TK thì lấy dữ liệu cột Lọc trong TK ngầm định
    if (proxy.dbOptions?.AllowRestrictAccountNumber) {
      if (param.col.dataField == 'debit_account') {
        buildFilterCombo('default_debit_account_category_id', extend, payload, param.row, ors);
      } else if (param.col.dataField == 'credit_account') {
        buildFilterCombo('default_credit_account_category_id', extend, payload, param.row, ors);
      }
      //Thêm trường hợp là tài khoản thuế
      //TVDAT 15/07/2022
      else if (param.col.dataField == 'tax_account') {
        buildFilterCombo('default_tax_account_category_id', extend, payload, param.row, ors);
      }
    }
    payload.filter = extendFilter(payload.filter, extend);
    return JSON.parse(payload.filter);
  };

  // config columns combo
  const accountComboMostDetailConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'account_number',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tài khoản',
        dataField: 'account_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'account_number',
    valueField: 'account_number',
    queryMode: 'remote',
    comboboxLoadData: onAccountComboboxLoadDataCustom,
    quickSearch: 'RemoteQuickSearchPopup',
    quickSearchParam: {
      titleSearch: 'tài khoản',
      payload: {
        sort: 'account_number',
        filterFunc: onAccountComboboxPayload,
      },
      module: ModuleAccount,
      idField: 'account_number',
    },
    dropdownWidth: 600,
  };

  return {
    accountComboMostDetailConfig,
    onAccountComboboxLoadDataCustom,
  };
};
